import React from "react";

import { GetCohortDetailsResponse } from "@/queries/get-cohort-details.types";
import { Country } from "react-phone-number-input";

export type DataContext = GetCohortDetailsResponse & {
  slug: string;
  __country: Country;
};

export type DataContextProps = {
  data: DataContext;
  setData: React.Dispatch<React.SetStateAction<DataContext>>;
};

export const dataContext = React.createContext<DataContextProps>(
  null as unknown as DataContextProps
);

const DataProvider = ({
  data,
  setData,
  children,
}: DataContextProps & {
  children: React.ReactNode;
}) => {
  return (
    <dataContext.Provider value={{ data, setData }}>
      {children}
    </dataContext.Provider>
  );
};

export { DataProvider };
